// The task-group wizard's and edit's network settings (D81): which network list the agents'
// containers use, and whether they share the VM's network (its VPN included).
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { Switch } from "rizzui";

import { useT } from "../i18n";
import { Hint, SelectField } from "../ui/SideDrawer";
import { networkListsQuery } from "./api";

interface Props {
  listId: string;
  share: boolean;
  onChange: (patch: { networkListId?: string; shareVmNetwork?: boolean }) => void;
}

export function NetworkFields({ listId, share, onChange }: Props) {
  const t = useT().network.wizard;
  const lists = useQuery(networkListsQuery());
  const options = [{ value: "", label: t.defaults }, ...(lists.data ?? []).map((l) => ({ value: l.id, label: l.name }))];
  // A list the API names but this page has not loaded yet still shows as chosen.
  if (listId && !options.some((o) => o.value === listId)) options.push({ value: listId, label: listId });
  return (
    <div className="grid gap-5 sm:grid-cols-2">
      <div>
        <SelectField label={t.list} value={listId} options={options} onChange={(networkListId) => onChange({ networkListId })} />
        <Hint>
          {t.listHint}{" "}
          <Link to="/network" target="_blank" className="font-medium text-primary hover:underline">
            {t.createList}
          </Link>
        </Hint>
      </div>
      <div className="sm:pt-7">
        <Switch role="switch" label={t.share} checked={share} onChange={(e) => onChange({ shareVmNetwork: e.target.checked })} />
        <Hint>{t.shareHint}</Hint>
      </div>
    </div>
  );
}
